import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import '@/App.css';
import Auth from '@/pages/Auth';
import LandingPage from '@/pages/LandingPage';
import Dashboard from '@/pages/Dashboard';
import Products from '@/pages/Products';
import Formula from '@/pages/Formula';
import ContainerStep from '@/pages/ContainerStep';
import Suppliers from '@/pages/Suppliers';
import Certificates from '@/pages/Certificates';
import Labels from '@/pages/Labels';
import Manufacturing from '@/pages/Manufacturing';
import Toxicology from '@/pages/Toxicology';
import DIPGeneration from '@/pages/DIPGeneration';
import LabProfile from '@/pages/LabProfile';
import SubscriptionPage from '@/pages/SubscriptionPage';
import { SubscriptionSuccess, SubscriptionCancel } from '@/pages/SubscriptionCallback';
import ProductionDashboard from '@/pages/production/ProductionDashboard';
import Materials from '@/pages/production/Materials';
import FinishedProducts from '@/pages/production/FinishedProducts';
import ProductRecipe from '@/pages/production/ProductRecipe';
import ProductionJournal from '@/pages/production/ProductionJournal';
import ProductionPlanning from '@/pages/production/ProductionPlanning';
import ShoppingList from '@/pages/production/ShoppingList';
import Support from '@/pages/Support';
import AdminSupport from '@/pages/AdminSupport';
import AdminUsers from '@/pages/AdminUsers';
import AdminBackup from '@/pages/AdminBackup';
import MentionsLegales from '@/pages/legal/MentionsLegales';
import CGU from '@/pages/legal/CGU';
import Confidentialite from '@/pages/legal/Confidentialite';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import MainLayout from '@/components/MainLayout';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  if (!user) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Auth onLogin={handleLogin} />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/legal/mentions" element={<MentionsLegales />} />
          <Route path="/legal/cgu" element={<CGU />} />
          <Route path="/legal/confidentialite" element={<Confidentialite />} />
          <Route path="/subscription/success" element={<SubscriptionSuccess />} />
          <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout user={user} onLogout={handleLogout} />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="product/:productId/formula" element={<Formula />} />
            <Route path="product/:productId/container" element={<ContainerStep />} />
            <Route path="product/:productId/suppliers" element={<Suppliers />} />
            <Route path="product/:productId/certificates" element={<Certificates />} />
            <Route path="product/:productId/labels" element={<Labels />} />
            <Route path="product/:productId/manufacturing" element={<Manufacturing />} />
            <Route path="product/:productId/toxicology" element={<Toxicology />} />
            <Route path="product/:productId/dip" element={<DIPGeneration />} />
            <Route path="lab-profile" element={<LabProfile />} />
            <Route path="subscription" element={<SubscriptionPage />} />
            
            {/* Production routes */}
            <Route path="production" element={<ProductionDashboard />} />
            <Route path="production/materials" element={<Materials />} />
            <Route path="production/products" element={<FinishedProducts />} />
            <Route path="production/product/:productId/recipe" element={<ProductRecipe />} />
            <Route path="production/journal" element={<ProductionJournal />} />
            
            {/* Planning & Forecasting routes */}
            <Route path="production/planning" element={<ProductionPlanning />} />
            <Route path="production/shopping-list" element={<ShoppingList />} />

            {/* Support */}
            <Route path="support" element={<Support />} />
            <Route path="admin/support" element={<AdminSupport />} />
            <Route path="admin/users" element={<AdminUsers />} />
            <Route path="admin/backup" element={<AdminBackup />} />
          </Route>
          <Route path="/legal/mentions" element={<MentionsLegales />} />
          <Route path="/legal/cgu" element={<CGU />} />
          <Route path="/legal/confidentialite" element={<Confidentialite />} />
          <Route path="/subscription/success" element={<SubscriptionSuccess />} />
          <Route path="/subscription/cancel" element={<SubscriptionCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
